export default __webpack_public_path__ + "static/media/gallery01.6d5882d7.jpg";